/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Citations_Open_SourceInputs */



/**
* | output |
* | --- |
* | "Open source in a new tab" |
*
* @param {Chat_Citations_Open_SourceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_citations_open_source = /** @type {((inputs?: Chat_Citations_Open_SourceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Citations_Open_SourceInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Quelle in neuem Tab öffnen")
	return /** @type {LocalizedString} */ ("Open source in a new tab")
});